import { React, useState } from "react";
import { Form, Grid, GridColumn, Header, Segment, FormField, Button, Message, FormInput, Icon } from "semantic-ui-react";
import { setLogin, setRegister, setSendResetToken, setUpdatePassword } from "../queries";
import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { readFromToken, UserRoles } from "../auth.ts";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppContext } from "../AppContext.jsx";

const ResetPasswordPage = () => {
    const { t } = useTranslation();

    const setResetPasswordMutiation = useMutation(setUpdatePassword, {
        onSuccess: (response) => onResetPassword(response),
        // onError
    });

    const onSubmitResetPassword = (e) =>{
        e.preventDefault();
        const { password } = Object.fromEntries(new FormData(e?.target));
        setResetPasswordMutiation.mutate({ password, token });  }


    const onResetPassword = (response) => {
        setPasswordWasChanged(true);
    }


    const [searchParams, setSearchParams] = useSearchParams();
    const [token, setToken]= useState(searchParams.get('token'));

    if(!token) window.location.href = '/'

    const [password,setPassword] = useState("");

    const [passwordWasChanged, setPasswordWasChanged]= useState(false);
    

    return(
        !passwordWasChanged?(
        <Grid container centered verticalAlign="middle" style={{ height: '100%' }}>
              <GridColumn textAlign="center" style={{ maxWidth: 450 }}>
                <Segment>
                  <Header textAlign="center" as="h2" icon="user md" content={t('ramot-clinic')} style={{ justifySelf: 'center' }}/>
                </Segment>
                    <Segment basic>
                        <Form onSubmit={(e) => onSubmitResetPassword(e)} loading={setResetPasswordMutiation.isLoading}>
                            <Segment>
                                <FormField>
                                <FormInput name="password" value={password} type="Password" placeholder={t('password')} onChange ={(_, { value }) => setPassword(value)}/>
                                </FormField>
                                <Button primary type='submit' size="large" fluid>{t('reset-password')}</Button>
                            </Segment>
                        </Form>
                    </Segment>
                <Segment basic></Segment>
            </GridColumn>
        </Grid>
        
        ):(
        <>
        <Message success>
            {t("password-updated")}
        </Message>
        <Button as="a" type='submit' size="large" fluid href = "/"> {t("back-to-home-page")}</Button>
        </>

        )
    )

};

export default ResetPasswordPage;
